import React from 'react';

interface MenuIconProps {
  className?: string;
}

const MenuIcon: React.FC<MenuIconProps> = ({ className = '' }) => {
  return (
    <svg
      className={`w-4 h-4 ${className}`}
      fill="none"
      stroke="#253658"
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <circle cx="12" cy="5" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="12" cy="19" r="1" />
    </svg>
  );
};

export default MenuIcon;
